export default function WeWorkedWith() {
    return (
        <div>
            <p className="fs-1 fw-bold">We've worked with</p>
            <div className="container">
                <div className="row">
                    <div className="col-4 col-sm-2 g-4 text-center">
                        <img
                            className="img-fluid"
                            src="./WeveWorkedWith/1.png"
                            alt=""
                        />
                    </div>
                    <div className="col-4 col-sm-2 g-2 text-center">
                        <img
                            className="img-fluid"
                            src="./WeveWorkedWith/2.png"
                            alt=""
                        />
                    </div>
                    <div className="col-4 col-sm-2 g-4 text-center">
                        <img
                            className="img-fluid"
                            src="./WeveWorkedWith/3.png"
                            alt=""
                        />
                    </div>
                    <div className="col-4 col-sm-2 g-4 text-center">
                        <img
                            className="img-fluid"
                            src="./WeveWorkedWith/4.png"
                            alt=""
                        />
                    </div>
                    <div className="col-4 col-sm-2 g-4 text-center">
                        <img
                            className="img-fluid"
                            src="./WeveWorkedWith/5.png"
                            alt=""
                        />
                    </div>
                    <div className="col-4 col-sm-2 g-3 text-center">
                        <img
                            className="img-fluid"
                            src="./WeveWorkedWith/6.png"
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
